import { createAction, props } from '@ngrx/store';

import { PayRoll, PayRollBatch } from '@models';

// upload pay-roll batch
export const uploadPayRollBatch = createAction(
  '[PayRoll] Upload PayRollBatch',
  props<{ file: File }>()
);
export const uploadPayRollBatchSuccess = createAction(
  '[PayRoll] Upload PayRollBatch Success',
  props<{ message: string }>()
);
export const uploadPayRollBatchFailed = createAction(
  '[PayRoll] Upload PayRollBatch Failed',
  props<{ error: Error }>()
);

// process pay-roll batch
export const processPayRollBatch = createAction(
  '[PayRoll] Process PayRollBatch',
  props<{ payRollBatchId: string }>()
);
export const processPayRollBatchSuccess = createAction(
  '[PayRoll] Process PayRollBatch Success',
  props<{ message: string }>()
);
export const processPayRollBatchFailed = createAction(
  '[PayRoll] Process PayRollBatch Failed',
  props<{ error: Error }>()
);

// fetch all pay-roll batches
export const fetchPayRollBatches = createAction(
  '[PayRoll] Fetch PayRollBatches'
);
export const fetchPayRollBatchesSuccess = createAction(
  '[PayRoll] Fetch PayRollBatches Success',
  props<{ payRollBatches: PayRollBatch[] }>()
);
export const fetchPayRollBatchesFailed = createAction(
  '[PayRoll] Fetch PayRollBatches Failed',
  props<{ error: Error }>()
);

// fetch pay-roll batch by id
export const fetchCurrentPayRollBatchById = createAction(
  '[PayRoll] Fetch PayRoll Batch By Id'
);
export const fetchCurrentPayRollBatchByIdSuccess = createAction(
  '[PayRoll] Fetch PayRoll Batch By Id Success',
  props<{ payRollBatch: PayRollBatch }>()
);
export const fetchCurrentPayRollBatchByIdFailed = createAction(
  '[PayRoll] Fetch PayRoll Batch By Id Failed',
  props<{ error: Error }>()
);

// fetch pay-roll by id
export const fetchCurrentPayRollById = createAction(
  '[PayRoll] Fetch PayRoll By Id'
);
export const fetchCurrentPayRollByIdSuccess = createAction(
  '[PayRoll] Fetch PayRoll By Id Success',
  props<{ payRoll: PayRoll }>()
);
export const fetchCurrentPayRollByIdFailed = createAction(
  '[PayRoll] Fetch PayRoll By Id Failed',
  props<{ error: Error }>()
);
